(function ($) {
  $(() => {
    // date valid +
    if (typeof jatek_data == "undefined" || !jatek_data) {
      return;
    }
    var has_trans = jatek_data.has_trans;



    if (
      new Date(jatek_data.date_begin * 1000) > serverTime ||
      new Date(jatek_data.date_end * 1000) < serverTime
    ) {
      $(".fantastic-bill-after-row").addClass("no-game-form");
      $(".bill-section").addClass("no-game-form-section");
      return;
    }

    $(".form-section").removeClass("d-none");

    if (!$("#online").length) {
      $(".game_ap").removeClass("d-none");
      if (!jatek_data.has_extra) {
        $("#game_ap").attr("required", true);
      }

      $("#online").val("");

      $(".hour-wrapper").show();
      $(".minute-wrapper").show();
      $(".hour-valid").show();
      $(".min-valid").show();

      $(".game-trans-group").show();
      $("#game_trans").attr("required", true);
      jatek_data.has_trans = has_trans;
      if (has_trans) {
        $('input[name ="trans_boolean"]').val(true);
      }
    }

    $(".code-type-select").on("change", function () {
      $(".game_ap").addClass("d-none");
      $(".game-online").addClass("d-none");
      $("#game_ap").attr("required", false);
      $("#online").attr("required", false);

      $(".game-ap-group").removeClass("is-error");
      $(".ap-valid").remove();

      $(".game-online").removeClass("is-error");
      $(".online-valid").remove();

      if ($(this).val() === "ap") {
        $(".game_ap").removeClass("d-none");
        if (!jatek_data.has_extra) {
          $("#game_ap").attr("required", true);
        }
        $("#game_ap").attr("required", true);
        $("#online").val("");

        $(".hour-wrapper").show();
        $(".minute-wrapper").show();
        $(".hour-valid").show();
        $(".min-valid").show();

        $(".game-trans-group").show();
        $("#game_trans").attr("required", true);
        jatek_data.has_trans = has_trans;
        if (has_trans) {
          $('input[name ="trans_boolean"]').val(true);
        }
      } else {
        $(".game-online").removeClass("d-none");
        if (!jatek_data.has_extra) {
          $("#online").attr("required", true);
        }
        $("#hour").trigger("reset");
        $("#min").trigger("reset");
        $("#game_ap").val("");

        $(".hour-wrapper").hide();
        $(".minute-wrapper").hide();

        $(".hour-valid").hide();
        $(".min-valid").hide();

        $(".game-trans-group").hide();
        $("#game_trans").attr("required", false);
        jatek_data.has_trans = false;
        $('input[name ="trans_boolean"]').val("");
      }
    });

    function namevalidation(inputtxt) {
      const regexp = /[a-zA-z áéíóöőúüűÁÉÍÓÖŐÚÜŰ -]+/g;
      if (inputtxt.match(regexp)) {
        return true;
      }
      return false;
    }

    function phonenumber(inputtxt) {
      const phoneno = /^((?:\+?3|0)6)(?:-|\()?(\d{1,2})(?:-|\))?(\d{3})-?(\d{3,4})$/;
      if (inputtxt.match(phoneno)) {
        return true;
      }

      return false;
    }

    function validateAP(inputtxt) {
      if (jatek_data.has_ap && !jatek_data.has_extra) {
        const ap = /(A|a)([0-9]{8})/g;
        if (inputtxt.match(ap)) {
          return true;
        }
        return false;
      }

      if (jatek_data.has_ap && jatek_data.has_extra) {
        if (inputtxt.length > 0) {
          const ap = /(A|a)([0-9]{8})/g;
          if (inputtxt.match(ap)) {
            return true;
          }
          return false;
        }
      }

      return true;
    }

    function validateOnline(inputtxt) {
      if (jatek_data.has_ap && !jatek_data.has_extra) {
        const online = /([0-9]{8})/g;
        if (inputtxt.match(online)) {
          return true;
        }
        return false;
      }

      if (jatek_data.has_ap && jatek_data.has_extra) {
        if (inputtxt.length > 0) {
          const online = /([0-9]{8})/g;
          if (inputtxt.match(online)) {
            return true;
          }
          return false;
        }
      }


      return true;
    }

    function validateTrans(inputtxt) {
      if (jatek_data.has_trans) {
        const trans = /^[0-9]{1,10}$/g;
        if (inputtxt.match(trans)) {
          return true;
        }

        return false;
      }

      return true;
    }

    function validateNav(inputtxt) {
      if (jatek_data.has_nav) {
        const nav = /[a-zA-Z0-9]+/g;
        if (inputtxt.match(nav)) {
          return true;
        }

        return false;
      }

      return true;
    }

    $(".game-form").parsley({
      trigger: "change",
      successClass: "is-success",
      errorClass: "is-error",
      classHandler(el) {
        return el.$element.closest(".form-group");
      },
      errorsWrapper: '<div class="invalid-message"></div>',
      errorTemplate: "<span class='error-span'></span>"
    });

    function resetGameForm() {
      $(".game-form").trigger("reset");
      grecaptcha.reset();
      $(".own-select").each(function () {
        $(this).trigger("reset");
      });

      $(".game_ap").addClass("d-none");
      $(".game-online").addClass("d-none");
      $(".hour-wrapper").show();
      $(".minute-wrapper").show();
      myDropzone.removeAllFiles();
    }

    // front-form
    $(".game-form").on("submit", function (e) {
      e.preventDefault();
      const $this = $(this);

      const lastname_string = $("#gamer_name");
      const tel_string = $("#game_tel");
      const ap_string = $("#game_ap");
      const online_string = $("#online");
      const trans_string = $("#game_trans");
      const nav_string = $("#game_nav");

      const year = $("#year option:selected", this).val();
      const month = $("#month option:selected", this).val();
      const day = $("#day option:selected", this).val();
      const hour = $("#hour option:selected", this).val();
      const min = $("#min option:selected", this).val();

      const code_type = $("#code-type option:selected", this).val();

      let valid = true;

      if (!namevalidation(lastname_string.val())) {
        if (!$(".name-valid").length) {
          $(".gamer-name-group").addClass("is-error");
          lastname_string
            .closest(".form-group")
            .append(
              '<div class="invalid-message name-valid">  <span class="error-span">A név mező csak betűt, szóközt és kötőjelet tartalmazhat.</span></div>'
            );
        }

        valid = false;
      }
      if (!phonenumber(tel_string.val())) {
        if (!$(".tel-valid").length) {
          $(".game-tel-group").addClass("is-error");
          tel_string
            .closest(".form-group")
            .append(
              '<div class="invalid-message tel-valid"> <span class="error-span">"A telefonszám formátuma hibás. Kérjük, csak számokat és + karaktert használjon! pl.: +36301234567</span></div>'
            );
        }
        valid = false;
      }

      if (code_type === "ap") {
        if (!validateAP(ap_string.val())) {
          if (!$(".ap-valid").length) {
            $(".game-ap-group").addClass("is-error");
            ap_string
              .closest(".form-group")
              .append(
                '<div class="invalid-message ap-valid"> <span class="error-span">Az AP-kód formátuma hibás, a kód "A" betűvel kezdődik és 8 számjegy követi. Kérjük, helyesbítse! (pl.: A01234567)</span></div>'
              );
          }

          valid = false;
        }
      } else {
        if (!validateOnline(online_string.val())) {
          if (!$(".online-valid").length) {
            $(".game-online").addClass("is-error");
            online_string
              .closest(".form-group")
              .append(
                '<div class="invalid-message online-valid"> <span class="error-span">A beírt rendelésszám nem megfelelő. Kérjük, ellenőrizze és helyesbítse! (pl.: 01234567)</span></div>'
              );
          }
          valid = false;
        }
      }

      if (!validateNav(nav_string.val())) {
        if (!$(".nav-valid").length) {
          $(".game-nav-group").addClass("is-error");
          nav_string
            .closest(".form-group")
            .append(
              '<div class="invalid-message nav-valid"> <span class="error-span">A NAV kód formátuma hibás, a kód 5 karaktert tartalmazhat. Kérjük, helyesbítse! (pl.: 4B567)A NAV kód formátuma hibás, a kód 5 karaktert tartalmazhat. Kérjük, helyesbítse! (pl.: 4B567)</span></div>'
            );
        }

        valid = false;
      }
      if (!validateTrans(trans_string.val())) {
        if (!$(".trans-valid").length) {
          $(".game-trans-group").addClass("is-error");
          trans_string
            .closest(".form-group")
            .append(
              '<div class="invalid-message trans-valid"> <span class="error-span">A tranzakciós szám formátuma hibás, maximum 10 számjegyből állhat. Kérjük, helyesbítse! (pl.: 0123456789)</span></div>'
            );
        }

        valid = false;
      }

      if (code_type === "-1") {
        if (!$(".type-valid").length) {
          $("#code-type")
            .closest(".code-type-wrapper")
            .append(
              '<div class="invalid-message code-type-valid"> <span class="error-span">A kód típus kiválasztása kötelező!</span></div>'
            );
        }

        valid = false;
      }

      if (year === "-1") {
        if (!$(".year-valid").length) {
          $("#year")
            .closest(".date-validate")
            .append(
              '<div class="invalid-message year-valid"> <span class="error-span">Kérjük válassza ki a vásárlás évét!</span></div>'
            );
        }

        valid = false;
      }

      if (month === "-1") {
        if (!$(".month-valid").length) {
          $("#month")
            .closest(".date-validate")
            .append(
              '<div class="invalid-message month-valid"> <span class="error-span">Kérjük válassza ki a vásárlás hónapját!</span></div>'
            );
        }

        valid = false;
      }
      if (day === "-1") {
        if (!$(".day-valid").length) {
          $("#day")
            .closest(".date-validate")
            .append(
              '<div class="invalid-message day-valid"> <span class="error-span">Kérjük válassza ki a vásárlás napját!</span></div>'
            );
        }

        valid = false;
      }

      if (code_type === "ap") {
        if (hour === "-1") {
          if (!$(".hour-valid").length) {
            $("#hour")
              .closest(".date-validate")
              .append(
                '<div class="invalid-message hour-valid"><span class="error-span">Kérjük válassza ki a vásárlás óráját!</span></div>'
              );
          }

          valid = false;
        }
        if (min === "-1") {
          if (!$(".min-valid").length) {
            $("#min")
              .closest(".date-validate")
              .append(
                '<div class="invalid-message min-valid"><span class="error-span">Kérjük válassza ki a vásárlás percét!</span></div>'
              );
          }

          valid = false;
        }
      }


      if (jatek_data.has_image) {
        if (jatek_data.image_upload_required) {
          if (myDropzone.files.length === 0) {
            swal({
              title: 'A kép feltöltése kötelező!',
              text: '',
              icon: 'error',
              button: "OK"
            });

            valid = false;
          }
        }


        if (myDropzone.files.length > 0 && !myDropzone.files[0].accepted) {
          if (myDropzone.files[0].status == "error") {
            swal({
              title: $('.dz-error-message').text(),
              text: '',
              icon: 'error',
              button: "OK"
            });

            valid = false;
          }
        }
      }


      if (!$(".first_check").prop("checked")) {
        if (!$(".first-check-error").length) {
          $(".first_check")
            .closest(".form-group")
            .append(
              '<div class="invalid-message first-check-error"><span class="error-span">A mező kitöltése kötelező!</span></div>'
            );
        }

        valid = false;
      }


      if (!$(".second_check").prop("checked")) {
        if (!$(".second-check-error").length) {
          $(".second_check")
            .closest(".form-group")
            .append(
              '<div class="invalid-message second-check-error"><span class="error-span">A mező kitöltése kötelező!</span></div>'
            );
        }

        valid = false;
      }


      if ($('.invalid-message').length) {
        $($('.invalid-message')[0]).parent()[0].scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
      }

      if (valid) {
        $(this)
          .find(".game-btn")
          .prop("disabled", true);
        const formdata = new FormData($this[0]);

        if (jatek_data.has_image) {
          formdata.append('file', myDropzone.files[0]);
        }
        formdata.append('action', 'game_form');

        $.ajax({
          url: ajax.ajaxurl,
          type: "POST",
          processData: false, // Prevent jQuery from processing the data
          contentType: false, // Prevent jQuery from setting the content type
          data: formdata,
          success(data) {
            const result = JSON.parse(data);
            if (result.status === "error") {
              swal({
                title: result.title,
                text: result.message,
                icon: result.icon,
                button: "OK"
              });
              grecaptcha.reset();
            }
            if (result.status === "success") {
              resetGameForm();
              $("#popup-modal").modal("show");
            }
          }
        }).done(response => {
          $this.find(".game-btn").prop("disabled", false);
        });
      }
    });

    // hiba uzenetek eltuntetese
    $("input")
      .on("input propertychange", function () {
        var $this = $(this);
        $this.siblings(".invalid-message").remove();
      })
      .trigger("propertychange");

    $(".own-select").change(function () {
      var $this = $(this);
      var id = $this.attr("id");
      var error_class = id + "-valid";
      $("." + error_class).remove();
    });
  });
})(jQuery);
